import React, { useState } from "react";
import Select from "react-select";

type Option = {
  value: string;
  label: string;
};




interface Props {
  onChange: (values: string[]) => void;
  Options:Option[];
  docs?:any[];
}

const MultiSelectCheckbox: React.FC<Props> = ({ onChange , Options , docs }) => {
  const [selected, setSelected] = useState<Option[]>([]);

  const filteredOptions = docs
  ? Options.filter((option) =>
      docs.some((doc) => doc.docName === option.value)
    )
  : [];

  const handleChange = (selectedOptions: Option[] | null) => {
    setSelected(selectedOptions || []);
    onChange(selectedOptions ? selectedOptions.map(option => option.value) : []);
  };

  return (
    <Select
    options={filteredOptions && filteredOptions.length > 0 ? filteredOptions : Options}
    isMulti
    value={selected}
    onChange={handleChange}
    closeMenuOnSelect={false}
    placeholder="Select options..."
  />
  );
};

export default MultiSelectCheckbox;
